import React, { useState } from 'react';
import PropTypes from 'prop-types';
import snakeCase from 'lodash/snakeCase';
import ManagedInput from 'components/form/managed_input';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import OfficeAssignees from './office_assignees';
import Options from 'components/form/managed_input/options';

const Assignee = ({ assignee, offices, officeAssigneeIds, setOfficeAssigneeIds, setAssignee, users }) => {
  const assigneeTypesSet = [];
  assigneeTypesSet.push({
    value: 'specificUser',
    label: 'Specific User',
    getAssignee: () => ({ assigneeId, assigneeType: snakeCase(assigneeType) }),
  });

  if (offices && offices.length > 1) {
    assigneeTypesSet.push({
      value: 'byOffice',
      label: 'By Office',
      getAssignee: () => ({ assigneeId, assigneeType: snakeCase(assigneeType) }),
    });
  }

  assigneeTypesSet.push({
    value: 'primaryBroker',
    label: 'Primary Broker',
    getAssignee: () => ({ assigneeId: null, assigneeType: snakeCase(assigneeType) }),
  });

  assigneeTypesSet.push({
    value: 'none',
    label: 'None',
    getAssignee: () => ({ assigneeId: null, assigneeType: null }),
  });

  const [assigneeId, setAssigneeId] = useState((assignee.assigneeId || users[0].value).toString());
  const [assigneeType, setAssigneeType] = useState(
    assigneeTypesSet.find(type => snakeCase(type.value) === assignee.assigneeType)?.value || 'none',
  );

  const assigneeTypeOptions = assigneeTypesSet.map(({ value, label }) => ({ label, value }));

  React.useEffect(() => {
    setAssignee(assigneeTypesSet.find(type => type.value === assigneeType).getAssignee());
  }, [assigneeId, assigneeType]);

  return (
    <>
      <ManagedFormGroup
        label="Assignee"
        name="assigneeType"
        options={assigneeTypeOptions}
        type="radioGroup"
        value={assigneeType}
        onValueChange={setAssigneeType}
      />

      {assigneeType === 'specificUser' && (
        <ManagedInput
          className="form-control mt-1 mb-3"
          name="assigneeId"
          type="select"
          value={assigneeId}
          onValueChange={setAssigneeId}
        >
          <Options options={users} />
        </ManagedInput>
      )}

      {assigneeType === 'byOffice' && (
        <OfficeAssignees
          officeAssigneeIds={officeAssigneeIds}
          offices={offices}
          setOfficeAssigneeIds={setOfficeAssigneeIds}
          users={users}
        />
      )}
    </>
  );
};

Assignee.propTypes = {
  assignee: PropTypes.shape({
    assigneeId: PropTypes.number,
    assigneeType: PropTypes.string,
  }).isRequired,
  officeAssigneeIds: PropTypes.object.isRequired,
  offices: PropTypes.array.isRequired,
  setAssignee: PropTypes.func.isRequired,
  setOfficeAssigneeIds: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
  ).isRequired,
};


export default Assignee;
